<template lang="pug">
  validation-observer(ref="observer", tag="div")
    app-divider(label="Geral").mb-30px
    el-row(:gutter="30")
      el-col(:span="8")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Unidade de Conservação: ", :required="true")
          el-select.input(
            v-model="jsonCadastro.cadastroUc.idVinculoProcessoUc"
            @change="setUc"
            :class="{'erro' : errors.length}"
            style="width: 100%;"
          )
            el-option(
              v-for="uc in ucs",
              :key="uc.idProcesso",
              :label="uc.nomeUc",
              :value="uc.idProcesso"
            )
          span.help.erro {{ errors[0] }}
      el-col(:span="8")
        app-label(label="Número do processo: ")
        el-input.input(
          :disabled="true"
          v-model="jsonCadastro.cadastroUc.numeroProcesso"
        )
      el-col(:span="8")
        app-label(label="Número do CNUC: ")
        el-input.input(
          :disabled="true"
          v-model="jsonCadastro.cadastroUc.informacoesAdministrativasUc.cnuc"
        )
    el-row(:gutter="30").mt-10px
      el-col(:span="8")
        app-label(label="Esfera administrativa: ")
        el-input.input(
          :disabled="true"
          v-model="jsonCadastro.cadastroUc.informacoesAdministrativasUc.esferaAdministrativa"
        )
      el-col(:span="8")
        app-label(label="Categoria do manejo: ")
        el-input.input(
          :disabled="true"
          v-model="jsonCadastro.cadastroUc.informacoesAdministrativasUc.categoriaManejo"
        )
</template>

<script>
import AppTextEditor from '@/components/AppTextEditor'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    AppTextEditor,
    AppLabel,
    AppDivider
  },

  props: {
    jsonCadastro: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      ucs: []
    }
  },

  async mounted () {
    this.ucs = await this.getProcessosUc()
    this.setUc()
  },

  methods: {
    ...mapActions({
      getProcessosUc: 'processo/getProcessosUc'
    }),
    setUc () {
      if (this.jsonCadastro.cadastroUc.idVinculoProcessoUc) {
        const uc = this.ucs.find(uc => uc.idProcesso === this.jsonCadastro.cadastroUc.idVinculoProcessoUc)
        if (uc) {
          const cadastroUcAux = {idVinculoProcessoUc: this.jsonCadastro.cadastroUc.idVinculoProcessoUc, numeroProcesso: uc.numeroProcesso, informacoesAdministrativasUc: {...uc}}
          this.jsonCadastro.cadastroUc = {...cadastroUcAux}
        }
      }
    },

    async validate () {
      return this.$refs.observer.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
.btns {
  margin-top: 2%;
}
.question {
  padding: 10px;
}
.card {
  width: 80%;
  margin-left: 10%;
  margin-top: 20px;
}
.floatRight {
  float: right;
}
.radio {
  margin: 5px;
}
.mt-10px {
  margin-top: 10px;
}
.mb-30px {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/cadastroRf/AppFormularioDadosGerais.vue